import { fetchWithToken, getWithToken, postWithToken } from "../authentication/AuthProvider";
import config, { apiUrl } from "../config";

const product = apiUrl + "/product";
const routes = {
  label: "Product",
  value: "product",
  root: product,
  new: product + "/new",
  new_epd: product + "/new_epd",
  delete: product + "/delete",
  update: product + "/update",
  update_bulk: product + "/update_bulk",
  archive: product + "/archive",
  unarchive: product + "/unarchive",
  hide: product + "/hide",
  unhide: product + "/unhide",
  get_hidden: product + "/get_hidden",
  collaborate: product + "/collaborate",
  uncollaborate: product + "/uncollaborate",
  duplicate: product + "/duplicate",
  save_product_info: product + "/save_product_info",
  save_scope_and_goals: product + "/save_scope_and_goals",
  save_supplier_info: product + "/save_supplier_info",
  get_photo: product + "/get_photo",
  get_spec_document: product + "/get_spec_document",
  get_safety_document: product + "/get_safety_document",
  get_mine: product + "/get_mine",
  get_from_admin: product + "/get_from_admin",
  get_published_template: product + "/get_published_template",
  get_from_my_workspace: product + "/get_from_my_workspace",
  get_my_company_archive: product + "/get_my_company_archive",
  get_internal_collaborates: product + "/get_internal_collaborates",
  get_external_collaborates: product + "/get_external_collaborates",
  get_mine_collaborates: product + "/get_mine_collaborates",
  get_supplier_and_product_by_id: product + "/get_supplier_and_product_by_id",
  get_total_gwp_by_env_type: product + "/get_total_gwp_by_env_type",
  get_total_gwp_by_stage: product + "/get_total_gwp_by_stage",
  get_comparison_gwp_by_stage: product + "/get_comparison_gwp_by_stage",
  get_by_id: product + "/get_by_id",
  get_pending_validation: product + "/get_pending_validation",
  save_mci: product + "/save_mci",
  generate_insight_5_0: product + "/generate_insight_5_0",
  generate_insight_3_5: product + "/generate_insight_3_5",
  generate_insight_deepseek: product + "/generate_insight_deepseek",
  generate_insight_gemini_flash: product + "/generate_insight_gemini_flash",
  generate_insight_gemini_flash_lite: product + "/generate_insight_gemini_flash_lite",
  generate_insight_gemini_pro: product + "/generate_insight_gemini_pro",
  get_insight: product + "/get_insight",
  request_validation: product + "/request_validation",
  set_validation_status: product + "/set_validation_status",
  retrieve: product + "/retrieve",
};
export const Product = {
  label: routes.label,
  value: routes.value,

  new: (data) => postWithToken(routes.new, data),
  newEPD: (product) => postWithToken(routes.new_epd, product),

  delete: (ids) => postWithToken(routes.delete, { ids }),

  update: (product) => postWithToken(routes.update, product),
  update_bulk: (products) => postWithToken(routes.update_bulk, products),

  archive: (ids) => postWithToken(routes.archive, { ids }),
  unarchive: (ids) => postWithToken(routes.unarchive, { ids }),

  hide: (ids) => postWithToken(routes.hide, { ids }),
  unhide: (ids) => postWithToken(routes.unhide, { ids }),
  get_hidden: () => postWithToken(routes.get_hidden),

  collaborate: (ids) => postWithToken(routes.collaborate, { ids }),
  uncollaborate: (ids) => postWithToken(routes.uncollaborate, { ids }),

  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),

  get_mine: () => postWithToken(routes.get_mine),
  get_from_my_workspace: () => getWithToken(routes.get_from_my_workspace),
  get_insight: (product_id) => postWithToken(routes.get_insight, { product_id }),
  get_photo: (id) => postWithToken(routes.get_photo, { id }),
  get_spec_document: (id) => postWithToken(routes.get_spec_document, { id }),
  get_safety_document: (id) => postWithToken(routes.get_safety_document, { id }),
  get_supplier_and_product_by_id: (id) => postWithToken(routes.get_supplier_and_product_by_id, { id }),
  get_by_id: (id) => postWithToken(routes.get_by_id, { id }),
  save_mci: (id, mci) => postWithToken(routes.save_mci, { id, mci }),
  get_mine_collaborates: () => postWithToken(routes.get_mine_collaborates),
  get_my_company_archive: () => getWithToken(routes.get_my_company_archive),
  get_external_collaborates: () => postWithToken(routes.get_external_collaborates),
  get_internal_collaborates: () => postWithToken(routes.get_internal_collaborates),
  get_from_admin: () => postWithToken(routes.get_from_admin),
  get_published_template: () => getWithToken(routes.get_published_template),
  get_total_gwp_by_env_type: (product_ids) => getWithToken(routes.get_total_gwp_by_env_type, { product_ids }),
  get_total_gwp_by_stage: (product_ids) => getWithToken(routes.get_total_gwp_by_stage, { product_ids }),
  get_comparison_gwp_by_stage: (ids) => postWithToken(routes.get_comparison_gwp_by_stage, { ids }),
  get_pending_validation: () => getWithToken(routes.get_pending_validation),

  save_product_info: (form) => fetchWithToken(routes.save_product_info, { ...config.method.POST, body: form }),
  save_scope_and_goals: (form) => fetchWithToken(routes.save_scope_and_goals, { ...config.method.POST, body: form }),
  save_supplier_info: (form) => fetchWithToken(routes.save_supplier_info, { ...config.method.POST, body: form }),

  generate_insight_5_0: (product_id) => postWithToken(routes.generate_insight_5_0, { product_id }),
  generate_insight_3_5: (product_id) => postWithToken(routes.generate_insight_3_5, { product_id }),
  generate_insight_deepseek: (product_id) => postWithToken(routes.generate_insight_deepseek, { product_id }),
  generate_insight_gemini_flash: (product_id) => postWithToken(routes.generate_insight_gemini_flash, { product_id }),
  generate_insight_gemini_pro: (product_id) => postWithToken(routes.generate_insight_gemini_pro, { product_id }),
  generate_insight_gemini_flash_lite: (product_id) => postWithToken(routes.generate_insight_gemini_flash_lite, { product_id }),

  request_validation: (ids) => postWithToken(routes.request_validation, { ids }),
  set_validation_status: ({ id, validation_status }) => postWithToken(routes.set_validation_status, { id, validation_status }),
  retrieve: (ids) => postWithToken(routes.retrieve, { ids }),
};
export const newEPD = async (body) => {
  const url = routes.new_epd;
  const response = await postWithToken(url, body);
  return await response.json();
};
